import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconChevronUp = /*@__PURE__*/ proxyCustomElement(class CosmosIconChevronUp extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'f967a50989c8c89da545647b42f418a5ebc83625', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '3c40ed0070d2e96ccf93e53d41c35ccc7d034200', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '80060a333f9e5be672e8aeebb31dc954a8baa154', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m10.65 6.29-5.82 5.83a.48.48 0 0 0 0 .7l.35.36a.51.51 0 0 0 .71 0L11 8.06l5.11 5.12a.51.51 0 0 0 .71 0l.35-.36a.48.48 0 0 0 0-.7l-5.81-5.83a.51.51 0 0 0-.71 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-chevron-up", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-chevron-up"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-chevron-up":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconChevronUp);
            }
            break;
    } });
}

export { CosmosIconChevronUp as C, defineCustomElement as d };
